import moment from "moment";
import React from "react";

function AssessmentSummary({ assessmentDetail }) {
  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-lg md:text-2xl mb-2 md:mb-4 font-bold">
        Candidate Evaluation Details
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Full Name
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {assessmentDetail && assessmentDetail.full_name}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase text-sm sm:text-base xl:text-lg  text-app-grey font-bold">
            Date of Evaluation
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {moment(
              assessmentDetail && assessmentDetail.assessment_date
            ).format("dddd, DD MMMM YYYY")}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Email Address
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {assessmentDetail && assessmentDetail.email_address}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Phone Number
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {assessmentDetail && assessmentDetail.phone_number}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Evaluation ID
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {assessmentDetail && assessmentDetail.assessment_uuid}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Evaluation Score
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {assessmentDetail && assessmentDetail.assessment_score}
          </p>
        </div>
      </div>
      <div className="space-y-2">
        <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
          Evaluation Recommendation
        </p>
        <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
          {assessmentDetail && assessmentDetail.assessment_recommendation}
        </p>
      </div>
      <div className="space-y-2">
        <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
          Selected Program
        </p>
        <p className="text-sky-500 text-xl sm:text-2xl xl:text-4xl font-semibold">
          {assessmentDetail && assessmentDetail.selected_program}
        </p>
      </div>
    </div>
  );
}

export default AssessmentSummary;
